import { init as initCore, initChameleon, initI18n } from '@bark/bark-core';

//router
import { routerUrl } from './router';

// run
export async function  main() {
    // core functions
    await initCore();

    //services
    initChameleon();

    // router functions
    routerUrl();
}

main().then(() => {
    console.log('seller app start')
})
